import React, { FC, useCallback, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import classes from '../../asset/css/subscription-detail/switch-button.module.scss';
import '../../asset/css/animations.css';

export const SwitchOffButton: FC<{
  animating: boolean;
  loading: boolean;
  btnClickFunc: () => void;
  animateCompleteFunc: () => void;
}> = ({ animating, loading, btnClickFunc, animateCompleteFunc }) => {
  const [animations, setAnimations] = useState<{ slide: boolean;scaleUp:boolean; gray: boolean; loading: boolean; complete: boolean }>({
    slide: false,
    scaleUp: false,
    gray: false,
    loading: false,
    complete: false,
  });

  const button = useRef<HTMLButtonElement>(null);

  const btnClickHandler = useCallback(() => {
    if (animating || loading) return;

    btnClickFunc();

    setAnimations({
      ...animations,
      slide: true,
    });
  }, [animating, animations, btnClickFunc, loading]);

  const checkLoadingHandler = useCallback(() => {
    const checkLoading = () => {
      setTimeout(() => {
        if (button!.current!.dataset.loading === 'true') {
          checkLoading();
          return;
        }

        setAnimations({
          ...animations,
          loading: true,
        });
      }, 100);
    };

    checkLoading();
  }, [animations]);

  return (
    <button
      className={animations.complete ? classes.switchBg : classes.switchBgActive}
      onClick={btnClickHandler}
      ref={button}
      data-loading={loading}
    >
      <div className={classes.switchOffChangedBg} hidden={!animations.loading}/>
      <div className={`${classes.switch} ${classes.switchOnBg} ${classes.switchRight}`} hidden={animations.slide} />
      <CSSTransition
        in={animations.slide}
        unmountOnExit
        timeout={200}
        classNames="switch-off-slide"
        onEntered={() => {
          setAnimations({
            ...animations,
            scaleUp: true,
          });
        }}
      >
        <div className={`${classes.switch} ${classes.switchRight} ${classes.switchOnBg}`} hidden={animations.loading} />
      </CSSTransition>
      <CSSTransition
          in={animations.scaleUp}
          unmountOnExit
          timeout={200}
          classNames="switch-off-scale-up"
          onEntered={() => {
            setAnimations({
              ...animations,
              gray: true,
            });
          }}
      >
        <div className={`${classes.switch} ${classes.switchLeft} ${classes.switchEarthBg} ${classes.switchOpacityZero}`} hidden={animations.gray} />
      </CSSTransition>
      <CSSTransition
        in={animations.gray}
        unmountOnExit
        timeout={3000}
        classNames="switch-off-gray"
        onEntered={checkLoadingHandler}
      >
        <div className={`${classes.switch} ${classes.switchLeft} ${classes.switchEarthBg}`} hidden={animations.loading} />
      </CSSTransition>
      <div className={`${classes.switch} ${classes.switchLeft} ${classes.switchOffBg}`} hidden={!animations.loading}/>
      <CSSTransition
        in={animations.loading}
        timeout={200}
        unmountOnExit
        classNames="switch-off-complete"
        onEntered={() => {
          setAnimations({
            ...animations,
            complete: true,
          });

          setTimeout(() => {
            animateCompleteFunc();
          }, 200);
        }}
      >
        <div className={`${classes.switch} ${classes.switchLeft} ${classes.switchEarthBg} ${classes.switchGray}`} />
      </CSSTransition>
    </button>
  );
};
